import { render } from "./StaticContentLayout.vue?vue&type=template&id=0ec8e269"
import script from "./StaticContentLayout.vue?vue&type=script&lang=js"
export * from "./StaticContentLayout.vue?vue&type=script&lang=js"

import "./StaticContentLayout.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__